'use client';

import { getSignedUrl } from '@3fourteen/core';
import { useQuery } from '@tanstack/react-query';
import { mainBugsnag } from 'helpers/bugsnag';

export function useSignUrl(key = '') {
  const {
    data: url,
    error,
    isLoading,
  } = useQuery({
    queryKey: [key],
    queryFn: async () => {
      return await getSignedUrl({
        bucket: '3fourteen-user-db',
        key,
      });
    },
    enabled: !!key,
    throwOnError: (error, query) => {
      mainBugsnag.notify(error, (event) => {
        event.context = 'useSignUrl()';
        event.addMetadata('Key', {
          key,
          query,
        });
      });

      return false;
    },
  });

  return {
    isLoading,
    url,
    error,
  };
}
